module.exports = __webpack_public_path__ + "static/media/golang_nil_channel.9642fec1.md";